import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const handleCategoryClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-500 border border-background-300/70 rounded-full mb-4 tracking-wide">
            Browse All Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            Explore the Spreadsheet by Category
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Every <strong>acbuyspreadsheet</strong> category is updated daily with the latest products, prices,
            and availability data. Pick a category to start comparing.
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="group bg-background-50 border border-background-200/40 rounded-xl overflow-hidden hover:border-background-300/60 transition-all duration-300"
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden bg-background-100/50">
                <img
                  src={cat.imgSrc}
                  alt={`${cat.name} — ACBuy Spreadsheet Database`}
                  title={`${cat.name} — ACBuy Spreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                    {cat.name}
                  </h3>
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {cat.count}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mb-4 leading-relaxed">
                  {cat.description}
                </p>
                <button
                  onClick={() => handleCategoryClick(cat.url)}
                  className="w-full py-2.5 border border-foreground-200 rounded-lg text-sm font-medium text-foreground-700 hover:bg-foreground-50 hover:border-foreground-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Browse Now
                  <i className="ri-arrow-right-up-line ml-1.5 text-xs"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}